import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';

import __DEPRECATED_defineResources from 'dpl/shared/fetching/deprecated/defineResources';
import { singleShelterResourceDefinition } from 'dpl/shared/utils/tptConnectResourceDefinitions';
import { resetParams, pushParams } from 'dpl/actions/query_params';
import { DOG_ID, SHELTER_ID } from 'dpl/constants/query_params';
import DetailsDogModal from 'dpl/shelter_search_results/components/DetailsDogModal';

function DetailsDogModalContainer(props) {
  if (!props.isOpen) {
    return null;
  }

  return <DetailsDogModal {...props} />;
}

DetailsDogModalContainer.propTypes = {
  isOpen: PropTypes.bool.isRequired
};

export default compose(
  connect(
    ({ queryParams }) => ({
      currentDogId: queryParams[DOG_ID],
      currentShelterId: queryParams[SHELTER_ID],
      isOpen: Boolean(queryParams[DOG_ID] && queryParams[SHELTER_ID])
    }),
    {
      onClose: () => resetParams(DOG_ID, { hash: true }),
      onDogClick: dogId => pushParams({ [DOG_ID]: dogId }, { hash: true })
    }
  ),
  __DEPRECATED_defineResources((_, { currentShelterId, isOpen }) => ({
    shelterData: {
      ...singleShelterResourceDefinition(currentShelterId),
      auto: isOpen
    }
  })),
  connect((_, { currentDogId, shelterData }) => {
    const { data: shelter } = shelterData.value;
    const { dogs } = shelter;
    const dogIdx = dogs.findIndex(({ id }) => id === Number(currentDogId));

    return {
      address: shelter.short_address,
      dog: dogs[dogIdx] || { photographs: [] },
      previousDog: dogs[dogIdx - 1],
      nextDog: dogs[dogIdx + 1]
    };
  })
)(DetailsDogModalContainer);
